<template>
  <swiper class="banner" :options="swiperOption">
    <swiper-slide v-for="(item, index) in swiperData" :key="index">
      <div class="swiper-list">
        <img
          :src="windowW <= 768 ? item.mimgUrl : item.imgUrl"
          alt=""
          class="w-100"
        />
        <div class="swiper-info">
          <p>{{ item.title }}</p>
          <p>{{ item.content }}</p>
          <ul>
            <li v-for="(tag, tagIndex) in item.descript" :key="tagIndex">
              {{ tag }}
            </li>
          </ul>
          <dl class="d-flex">
            <dd v-for="(links, linksIndex) in item.btn" :key="linksIndex">
              <a :href="links.route">
                <img :src="links.icon" alt="" />
                <span>{{ links.text }}</span>
              </a>
            </dd>
          </dl>
        </div>
      </div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination" v-if="pagination"></div>
  </swiper>
</template>

<script>
import { mapState } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  props: {
    swiperData: {
      type: Array,
      require: true,
    },
    pagination: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: ".banner .swiper-pagination",
          clickable: true,
        },
        autoplay: {
          disableOnInteraction: false,
        },
        speed: 1000,
        effect: "fade",
      },
    };
  },
  computed: {
    ...mapState({
      windowW: (state) => state.config.windowW,
    }),
  },
};
</script>
<style lang="less">
.banner {
  .swiper-list {
    position: relative;
    .swiper-info {
      position: absolute;
      top: 50%;
      left: 10%;
      transform: translate(0, -50%);
      p {
        font-weight: bold;
        &:nth-of-type(1) {
          font-size: 48px;
          color: #004cba;
        }
        &:nth-of-type(2) {
          font-size: 30px;
        }
      }
      ul {
        margin-top: 26px;
        li {
          font-size: 17px;
          color: #8493a8;
          line-height: 30px;
        }
      }
      dl {
        margin-top: 40px;
        dd {
          width: 137px;
          line-height: 40px;
          text-align: center;
          border-radius: 6px;
          cursor: pointer;
          a {
            display: block;
          }
          img {
            width: 22px;
            margin-right: 12px;
          }
          &:nth-of-type(1) {
            margin-right: 10px;
            background-color: #2da9e5;
          }
          &:nth-of-type(2) {
            background-color: #004cba;
          }
          span {
            font-size: 14px;
            color: #fff;
          }
          &:hover {
            span {
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  .swiper-pagination-bullet {
    opacity: 1;
    background: transparent;
    border: 2px solid #004cba;
    &.swiper-pagination-bullet-active {
      width: 100px;
      border-radius: 10px;
      background: #004cba;
    }
  }
}
@media (max-width: 1200px) {
  .banner .swiper-list .swiper-info p:nth-of-type(1) {
    font-size: 32px;
    margin-bottom: 0;
  }
  .banner .swiper-list .swiper-info p:nth-of-type(2) {
    font-size: 24px;
  }
  .banner .swiper-list .swiper-info ul li {
    font-size: 12px;
    line-height: 20px;
  }
  .banner .swiper-list .swiper-info dl {
    margin-top: 20px;
  }
  .banner .swiper-list .swiper-info dl dd {
    width: 100px;
  }
  .banner .swiper-list .swiper-info dl dd span {
    font-size: 12px;
  }
  .banner .swiper-list .swiper-info dl dd img {
    width: 16px;
    margin-right: 8px;
  }
  .banner .swiper-list .swiper-info ul {
    margin-top: 10px;
  }
}
@media (max-width: 768px) {
  .banner .swiper-list .swiper-info {
    display: none;
  }
}
</style>
